export default {
    'pre-call-analysis': 'تحليل ما قبل المكالمة',
    'call': 'اتصال'
}